// =============================================================================
// MeuDriver — PageTabs
// =============================================================================
// Junta páginas que mostravam quase a mesma coisa (ex.: Financeiro + Ganhos do
// instrutor; Financeiro + Pagamentos do admin) numa só, com abas. A aba aberta
// fica em `?aba=` para que os endereços antigos redirecionem para a aba certa.

import { useSearchParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

export interface PageTab {
  value: string
  label: string
  content: React.ReactNode
}

export function PageTabs({ tabs }: { tabs: PageTab[] }) {
  const [params, setParams] = useSearchParams()
  const current = tabs.some((t) => t.value === params.get('aba')) ? params.get('aba')! : tabs[0].value

  function change(value: string) {
    const next = new URLSearchParams(params)
    if (value === tabs[0].value) next.delete('aba')
    else next.set('aba', value)
    setParams(next, { replace: true })
  }

  return (
    <Tabs value={current} onValueChange={change} className="space-y-6">
      <TabsList>
        {tabs.map((t) => (
          <TabsTrigger key={t.value} value={t.value}>{t.label}</TabsTrigger>
        ))}
      </TabsList>
      {tabs.map((t) => (
        <TabsContent key={t.value} value={t.value} className="mt-0">
          {t.content}
        </TabsContent>
      ))}
    </Tabs>
  )
}

export default PageTabs
